import { UnderwriterSearchRequestQuery } from '@lio/api-types';

export const searchUnderwriterQueryParams = (params: UnderwriterSearchRequestQuery) => {
  const { name, email, sort, pageLimit, pageOffset, includeCountOpenQuotes, includeDeleted } = params;
  const query = new URLSearchParams();

  if (name) {
    query.append('name', name);
  }
  if (email) {
    query.append('email', email);
  }
  if (includeCountOpenQuotes) {
    query.append('includeCountOpenQuotes', 'true');
  }
  if (sort) {
    query.append('sort', sort);
  }
  if (pageLimit) {
    query.append('pageLimit', String(pageLimit));
  }
  if (pageOffset) {
    query.append('pageOffset', String(pageOffset));
  }

  if (includeDeleted === true || (includeDeleted as any) === 'true') {
    query.append('includeDeleted', 'true');
  }

  return query.toString();
};
